module.exports = __webpack_public_path__ + "img/trial2-1.5e5810c2.png";